<template>
  <component :is="layout" v-show="ready" />
</template>


<script setup>
import defaultLayout from './core-components/layouts/default.vue';
import fullBleedLayout from './core-components/layouts/full-bleed.vue';
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import { onBeforeMount, computed, ref } from 'vue';
import { useContextStore } from '@wholebodyapp/stores';

const route = useRoute();
const router = useRouter();
const layout = computed(()=> {
  if (route.meta.layout === 'fullBleed')
    return fullBleedLayout;
  if (route.meta.layout === 'default')
    return defaultLayout;
  return defaultLayout;
});
const context = useContextStore();
const ready = ref(false);

onBeforeMount(() => {
  console.log('app.vue, beforeCreate()');
  context.initContextFromStorage();
  // just a dleay to keep th flash down. Could also use a
  // transition?
  setTimeout(()=> ready.value = true, 50);
});

</script>


<style lang="scss">


</style>
